import { get } from 'helpers/api';
import { getRequestReference } from 'helpers/axios';

export const ACTIVITIES_LOAD_STARTED = 'ACTIVITIES_LOAD_STARTED';
function loadStarted(requestReference) {
  return {
    type: ACTIVITIES_LOAD_STARTED,
    requestReference,
  };
}

export function loadActivities() {
  return async (dispatch, getState) => {
    const { deal, activitiesSearch: search } = getState();

    if (search.requestReference) {
      search.requestReference.cancel();
    }

    const requestReference = getRequestReference();
    dispatch(loadStarted(requestReference));

    const response = await get(deal.activitiesPath, {
      cancelToken: requestReference.token,
    });

    dispatch(setActivities(response.activities));
  };
}

export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export function setActivities(activities) {
  return {
    type: SET_ACTIVITIES,
    activities,
  };
}
